import React, { useEffect, useState } from "react";
import "./TheTeacherDashboard.css";
import Subjects from "./imageFiles/Subjects.png";

export default function ExamStatusStatistics({ dashboard_data,initial_loading,employeeType }) {
  const [activeTab, setActiveTab] = useState("Review");

  const [examData, setExamData] = useState({
    Review: [],
    "In-Review": [],
    "Refer-Back": [],
    "Review Completed": [],
    "Ready to publish": [],
    Published: [],
  });

  const tabs = Object.keys(examData);

  useEffect(() => {
    if (
      dashboard_data?.success &&
      dashboard_data.data?.status_wise_assigned_latest_assessments
    ) {
      const assessments = dashboard_data.data.status_wise_assigned_latest_assessments;

      const statusMap = {
        Initial: "Initial",
        Ready: "Ready",
        ProofReading: "ProofReading",
        Review: "Review",
        InReview: "In-Review",
        ReferBack: "Refer-Back",
        ReviewCompleted: "Review Completed",
        ReadyToPublish: "Ready to publish",
        Published: "Published",
      };

      const adminAllowed = [
        "Initial", 
        "Ready", 
        "ProofReading",
        "Review",
        "In-Review",
        "Refer-Back",
        "Review Completed",
        "Ready to publish",
        "Published"
      ];
      const teachAllowed = [
        "Review",
        "In-Review",
        "Refer-Back",
        "Review Completed",
        "Ready to publish",
        "Published",
      ];

      const allowedStatuses =
        (employeeType === "MASAD" || employeeType === "DEOP")
          ? adminAllowed
          : teachAllowed;

      const updatedExamData = allowedStatuses.reduce((acc, status) => {
        acc[status] = [];
        return acc;
      }, {});

      for (const [statusKey, exams] of Object.entries(assessments)) {
        const mappedKey = statusMap[statusKey];
        if (allowedStatuses.includes(mappedKey)) {
          updatedExamData[mappedKey] = exams.map(
            (exam) => `${exam.title} (ID: ${exam.asmnt_id || exam.assessment_id})`
          );
        }
      }

      setExamData(updatedExamData);
    }
  }, [dashboard_data, employeeType]);

  return (
    <div className="exam-status-wrapper card">
      <h6 className="exam-status-title mb-3">{employeeType === "TEACH"?'My Paper Details Status Statistics':'Paper Details Status Statistics'}</h6>
      <div className="tabs-section d-flex align-items-center">
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`tab-button ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>

      <div className="exam-list mt-6">
        {examData[activeTab].length > 0 ? (
          examData[activeTab].slice(0, 5).map((exam, index) => (
            <div key={index} className="exam-row d-flex align-items-center mb-3">
              <img
                src={Subjects}
                alt="exam-icon"
                className="exam-icon me-3"
              />
              <span className="exam-text">{exam}</span>
            </div>
          ))
        ) : (
          <p className="no-data text-muted">No data available for {activeTab}</p>
        )}
      </div>
    </div>
  );
}
